const messages = {
    login: "Login",
    loginFailed: "Login failed",
    register: "Register",
    loginToInvestorAccount: "Login to investor account",
    forgotPassword: "Forgot password?",
    dontHaveAccount: "Don't have an account?",
    loggingOut: "Logging out",
    tokenExpired: "Token expired",
    redirectingToLogin: "Redirecting to login",
    passwordHasChanged: "Your password has been changed",
    resetPassword: "Reset password",
    passwordCriteria: "Password must be at least 8 characters long and contain at least 6 unique characters.",
    enterAuthCode: "Enter authentication code",
    phoneVerification: "Phone verification",
    authCodeSent: "A verification code was sent to phone number {0}.",
    authCodeResent: "A verification code was re-sent to your phone number {0}.",
    authenticate: "Authenticate",
    resendCode: "Resend code",
    checkEmail: "Please check your email!",
    waitForPasswordLinkEmail: "In a few minutes you will receive e-mail with a link to the password renewal form.",
    confirmVerification: "(Testing) Confirm verification",
    enterEmailForPasswordReset: "Enter your account email address and we will send you a link to reset your password.",
    send: "Send",
    view: "View",
    acceptTerms: "Accept terms",
    enterBankDetails: "Enter bank details",
    attachedDocuments: "Attached documents",
    presentation: "Presentation",
    financialReports: "Financial reports",
    fundsRequested: "Funds requested",
    trancheNo: "Tranche #",
    maturityDate: "Maturity date",
    interestRate: "Interest rate",
    availableToInvest: "Available to invest",
    yourInvestments: "Your investments",
    dateOfCreation: "Date of creation",
    employees: "Employees",
    country: "Country",
    kildeRating: "Kilde rating",
    loanType: "Loan type",
    website: "Website",
    loanOriginated: "Loan originated",
    loansPortfolio: "Loans portfolio",
    loansOnKilde: "Loans on Kilde",
    paid: "PAID",
    amountAvailable: "Amount available",
    countries: "Countries",
    industry: "Industry",
    borrowingOnKilde: "Issuance on Kilde",
    year: "Year",
    company: "Company",
    foundedYear: "Founded year",
    thankYouRegister: "Welcome to Kilde and thanks for registering with us.",
    activateAccount: "To activate your account, please complete the steps below and provide required documents. You will receive a notification email once your account is activated, and will be able to deposit, invest and withdraw funds.",
    thankYouSubmission: "Thank you for your submission!",
    thankYouSubmissionDescription: "Thank you for your submission! We are reviewing your submitted documents. Once the review process is complete and your KYC requirements are met, your account will be activated, and you will be able to start investing.",
    documentVerification: "Document verification",
    enterPersonalDetails: "Enter personal details",
    investorVerification: "Investor verification",
    accreditedInvestorVerification: "Accredited investor status verification",
    accreditedInvestorVerificationDesc: "Kilde is a regulated financial entity in Singapore, and in line with our current regulatory license, we can only onboard investors who qualify as 'Accredited' or 'Institutional' as defined by the Securities and Futures Act.",
    accreditedInvestorVerificationDesc2: "There are three ways how to confirm your accredited investor status - through annual income, financial assets, or personal assets. If you meet the criteria of any of the three, congratulations, you are an accredited investor according to Singaporean regulations.",
    income: "Income",
    financialAssets: "Financial Assets",
    incomeDesc: "Your income exceeding SGD 300,000 (about USD 224,000) in the past 12 months is\n" +
        "                            enough to qualify you as an\n" +
        "                            accredited investor. The easiest way to document this is with the payment slips. On top of\n" +
        "                            employment income,\n" +
        "                            you can count in any rental income, dividends, interest, etc. Those you can document with\n" +
        "                            the rental contract,\n" +
        "                            dividend vouchers or bond certificates.",
    financialAssetsDesc: "Your financial assets of SGD 1,000,000 (about USD 745,000) or more at the time of\n" +
        "                            application. Those are your\n" +
        "                            financial assets like money in the bank accounts, deposits, shares and bonds, life policies,\n" +
        "                            gold or cryptocurrency\n" +
        "                            assets. If you own a business, the shares are classified as financial assets. You can\n" +
        "                            document this with an\n" +
        "                            investment account statement, bank statement, certificate of holdings, or other means. In\n" +
        "                            the case of your own\n" +
        "                            business, you can provide the latest financial statements to confirm the value of the\n" +
        "                            shares. Should you have\n" +
        "                            any margin brokerage account or a credit line that finances your investment portfolio, the\n" +
        "                            margin or credit line\n" +
        "                            would be deducted from the financial assets.",
    personalAssets: "Personal Assets",
    personalAssetsDesc: "Your personal assets of SGD 2,000,000 (about USD 1,490,000) or more at the time\n" +
        "                            of application. Personal assets include the financial assets described above. On top of that, you can count in the\n" +
        "                            market value of the assets you own. Typically, this would be residential or commercial properties, yachts, sport\n" +
        "                            cars, collectibles, and others. If you include the house you live in, its value will be counted maximum as SGD\n" +
        "                            1,000,000 (about USD 745,000). Should you have any loans like a mortgage, those would be deducted from the\n" +
        "                            personal assets.\n" +
        "                            Example of documents are certificate of house ownership or registration of a vehicle and the\n" +
        "                            documents listed in the financial assets.",
    informationComplete: "Now you have the necessary information to assess your profile.",
    proceed: "Proceed",
    congratulations: "Congratulations!",
    youAreAccredited: "In accordance with the assessment, you are considered as an accredited investor.",
    accreditedInvestorConsentRequired: "You need to provide your consent to be treated as the Accredited Investor in the meaning determined the\n" +
        "                        Securities and Futures Act (Chapter 289) of Singapore in relations with Kilde Pte. Ltd. and Issuers of the\n" +
        "                        securities offered for the subscription on this Platform.",
    agree: "AGREE",
    thankYou: "Thank you!",
    teamWillContact: "Our team will contact you shortly, so please be prepared to share with us the documentation to confirm your statement.",
    documentationExamplesDesc: "Please refer to the examples of the documentation we would expect from you below. Note that the\n" +
        "                        statement(s) should cover the past 12 months in case of income, except for the statements, which are\n" +
        "                        originated periodically (i.e.: yearly Tax Declaration report), in which case, the most recent version would be\n" +
        "                        acceptable. The personal and financial asset statements should be not older than 3 months.",
    paySlips: "Pay slips / Tax declaration",
    bankStatements: "Bank statements",
    investmentStatements: "Investment statements (Capital Market Products, Bullion, Stock, Cryptocurrency holdings)",
    lifePolicy: "Investment life policy statement",
    financialStatementsDesc: "Financial statements and business registry excerpt confirming the value of your shares in private companies",
    excerptFromLand: "Excerpt from land / property registry",
    ok: "OK",
    unableToConfirmAccredited: "We are unable to confirm your accredited investor status",
    thankYouForInterest: "Thank you for your interest in Kilde.",
    registrationNotPossible: "Unfortunately, at this time, we are unable to complete your registration and onboard you as an investor. Kilde is a regulated financial entity in Singapore, and in line with our current regulatory license, we can only onboard investors who qualify as \"Accredited\" or \"Institutional\" as defined by the Monetary Authority of Singapore.",
    revisitQuestionnaire: "I WANT TO REVISIT THE QUESTIONNAIRE",
    acknowledgeStatus: "I ACKNOWLEDGE MY STATUS",
    goBack: "Go back",
    accountNotActive: "Your account is not active",
    accountNotActiveDesc: "You will be able to deposit, invest and withdraw funds after your account is activated",
    noTranchesAvailable: "Sorry, no tranches available for investment currently...",
    registration: "Registration",
    registeredSuccess: "We successfully registered your application. Thank you for your interest. Our team will contact you for further details.",
    registerAsLegal: "Are you registering as a legal entity? Sign up",
    newRegisterAsLegalMessage: "Kilde products are intended for accredited, professional and institutional investors",
    alreadyRegistered: "Already registered?",
    logIn: "Log in",
    verifyEmail: "Verifying your email",
    somethingHappened: "Oops, something wrong happened.",
    pleaseClickToLogin: "Please click here to login and resend verification email",
    didntGetEmail: "Did not get a verification email?",
    checkSpam: "Check your Spam folder or click the button below to receive it again.",
    linkWasSent: "A verification link was sent to your email. Please check your inbox and verify email by following the provided link.",
    resendVerification: "Resend verification email",
    submit: "Submit",
    verifyYourPhone: "Verify your phone",
    didntGetCode: "Did not get a verification code?",
    resendVerificationCode: "Resend verification code",
    verify: "Verify",
    cannotOnboard: "Unfortunately, at this time, we are unable to complete your registration and onboard you as an investor. Kilde is a regulated financial entity in Singapore, and in line with our current regulatory license, we can only onboard investors who qualify as \"Accredited\" or \"Institutional\" as defined by the Monetary Authority of Singapore.",
    aiMeaning: "Accredited investor “AI” means:",
    individual: "(i) An individual",
    aiMeaningA: "(A) whose net personal assets exceed in value SGD 2,000,000 (or its equivalent in a foreign\n" +
        "            currency) or\n" +
        "            such\n" +
        "            other amount as the Authority may prescribe in place of the first amount, and in\n" +
        "            determining whether an\n" +
        "            individual's net personal assets exceeds the minimal amount, the estimated fair market\n" +
        "            value of an\n" +
        "            individual's\n" +
        "            primary residence less any outstanding amounts in respect of any credit facility granted\n" +
        "            to the\n" +
        "            individual\n" +
        "            or\n" +
        "            any other person that is secured by that residence, shall not account for more than\n" +
        "            SGD 1,000,000 (or its\n" +
        "            equivalent in a foreign currency) of the minimum amount; or",
    aiMeaningB: "(B) whose income in the preceding 12 months is not less than SGD 300,000 (or its equivalent\n" +
        "            in a foreign\n" +
        "            currency) or such other amount as the Authority may prescribe in place of the first\n" +
        "            amount;",
    aiMeaningII: "(ii) A corporation with net assets exceeding SGD 10 million in value (or its equivalent in a foreign\n" +
        "            currency) or\n" +
        "            such other amount as the Authority may prescribe, in place of the first amount, as determined by:",
    aiMeaningIIA: "(A) the most recent audited balance-sheet of the corporation; or",
    aiMeaningIIB: "(B) where the corporation is not required to prepare audited accounts regularly, a balance-sheet of the\n" +
        "            corporation certified by the corporation as giving a true and fair view of the state of affairs of the\n" +
        "            corporation as of the date of the balance-sheet, which date shall be within the preceding 12 months",
    questions: "If you still have questions, or would like to obtain further clarifications, feel free to contact us over email at <a href=\"mailto:info@kilde.sg\" class=\"text-primary-500\">info@kilde.sg</a> or <a @click=\"bookACall\" class=\"text-primary-500\">book a call</a>.",
    yoursKilde: "Yours,<br/> Kilde",
    about: "About",
    menu: "Menu",
    dashboard: "Dashboard",
    pagination: "{0} per page",
    autoInvestment: "Autoinvestment",
    autoInvestmentDesc: "<li>Make a deposit by bank transaction. Please remember to add your Investor's Account\n" +
        "                    Number in Payment Details!\n" +
        "                </li>\n" +
        "                <li>Wait for the deposit to be processed (can take up to two business days).\n" +
        "                </li>\n" +
        "                <li>Create your own autoinvestments strategy.</li>\n" +
        "                <li>Put your money to work!</li>",
    createAutoInvestment: "Create an autoinvestment strategy",
    autoInvestmentFaq: "Autoinvestment FAQ",
    strategies: "Autoinvestment strategies",
    status: "Status",
    currency: "Currency",
    remainingTerm: "Remaining loan term",
    portfolioSize: "Portfolio size",
    outstandingPrincipal: "Outstanding principal",
    edit: "Edit",
    pause: "Pause",
    activate: "Activate",
    delete: "Delete",
    strategyName: "Name of the strategy",
    maxInvestment: "Maximum investment in one borrower",
    maximumLimit: "The maximum limit of the auto investment strategy",
    pleaseSelect: "Please select",
    loanOriginator: "Loan originator",
    readTerms: "I have read and accept the terms of",
    noteOfAcceptance: "Note of Acceptance",
    noInvestments: "No investments",
    saveAndInvest: "Save and invest",
    investPreview: "With these parameters we have {0} available from {1} borrowers",
    iAccept: "I accept",
    terms: "Terms of use",
    privacyPolicy: "Privacy policy",
    identityVerificationInProgress: "Identity verification in progress",
    accountActivation: "Account activation",
    accountInformation: "Account information",
    firstName: "First name",
    lastName: "Last name",
    email: "Email",
    phone: "Phone",
    accountNumber: "Account number",
    startDate: "Start date",
    endDate: "End date",
    transactionType: "Transaction type",
    search: "Search",
    reset: "Reset",
    exportExcel: "Export to excel",
    openingBalance: "Opening balance",
    closingBalance: "Closing balance",
    bankDetails: "Bank details",
    committedInvestments: "Committed investments",
    reservedInvestments: "Reserved investments",
    reservedPrincipal: "Reserved principal",
    noCommittedInvestments: "You have no committed investments.",
    noReservedInvestments: "You have no reserved investments.",
    nextPaymentDate: "Next payment date",
    nextPaymentAmount: "Next payment amount",
    nextPayment: "Next payment",
    cancel: "Cancel",
    approve: "Approve",
    date: "Date",
    amount: "Amount",
    uploadDocuments: "Upload documents",
    uploadDocumentsDesc: "To comply with AML and KYC requirements, please verify your place of residence by uploading:",
    passport: "Passport",
    idCard: "ID card",
    dragAndDrop: "Drag & Drop or click here to select a file",
    idealExample: "Ideal example:",
    idFront: "Id card (front)",
    idBack: "Id card (back)",
    proofOfAddress: "Proof Of Residential Address",
    proofOfAddressDesc: "Copy of a bill (e.g. utility, mobile, internet, etc), bank statement with address or tenant\n" +
        "                        agreement.\n" +
        "                        <br/>\n" +
        "                        <strong>Document should not be older than 3 months.</strong>",
    wallet: "Wallet",
    amountToWithdraw: "Amount to withdraw",
    withdraw: "Withdraw",
    currencyExchangeTab: "Currency exchange",
    currencyExchangeTitle: "Wallet transfer request",
    currencyExchangeRequestFromLabel: "From",
    currencyExchangeRequestToLabel: "To",
    currencyExchangeRequestAmountLabel: "Amount",
    currencyExchangeRequestAdditionalNotesLabel: "Additional notes",
    currencyExchangeRequestSubmit: "Submit",
    credentialsOfBeneficiary: "Credentials of beneficiary",
    bank: "Bank",
    beneficiaryName: "Beneficiary name",
    beneficiaryAccountNumber: "Beneficiary Bank Account Number",
    beneficiaryRegNumber: "Beneficiary Registration Number",
    beneficiaryBankSwift: "Beneficiary Bank SWIFT/BIC Code",
    beneficiaryBankAddress: "Beneficiary Bank Address",
    beneficiaryAddress: "Beneficiary Address",
    paymentDetails: "Payment Details",
    investorAccountNumber: "Investor Account Number",
    paymentInstruction: "Payment instruction",
    addFunds: "To add funds",
    addFundsDesc: "<li class=\"mb-4\">Make a deposit by bank transaction, using the credentials on the right.\n" +
        "                Please\n" +
        "                remember to add your Investor's Account Number in Payment Details!\n" +
        "            </li>\n" +
        "            <li class=\"mb-4\">Wait for the deposit to be processed (can take up to two business\n" +
        "                days).\n" +
        "            </li>\n" +
        "            <li>Put your money to work!</li>",
    additionalDocuments: "Additional documents",
    additionalDocumentsDesc: "If the support team has requested that you upload additional documentation, you can do so here.",
    upload: "Upload",
    changePassword: "Change password",
    passwordChanged: "Password successfully changed",
    documentUploaded: "Document successfully uploaded",
    borrower: "Borrower",
    companyName: "Company name",
    loansOriginated: "Loans originated",
    loanPortfolio: "Loan portfolio",
    numberOfEmployees: "Number of employees",
    trancheDetails: "Tranche details",
    trancheAmount: "Tranche amount",
    nominalValue: "Nominal value",
    issueDate: "Issue date",
    interestComDate: "Interest commencement date",
    collateral: "Collateral",
    memorandum: "Memorandum",
    subsAgreement: "Subscription agreement",
    pricingSupplement: "Pricing supplement",
    tranche: "tranche",
    getOffer: "Invest",
    getOfferProblem: "There was a problem generating offer",
    principal: "Principal",
    accruedInterest: "Accrued interest",
    subscriptionFee: "Subscription fee",
    fundsToCommit: "Total funds to commit",
    discountedPrice: "Discounted price",
    investmentTerms: "investment terms",
    letterOfWaiver: "Letter of Waiver",
    commit: "Commit",
    investmentDetails: "Your investment details",
    reservationDetails: "Your reservation details",
    noInvestmentsInTranche: "You have no investments in the tranche",
    totalInvestments: "Total investments",
    fundedInvestments: "Funded investments",
    totalInvestedInBorrower: "Total investments into borrower",
    totalIncome: "Total income",
    totalIncomeDesc: "Formula: Interest received (+) Interest forecast (-) Fee expenses (-) Accrued interest expense",
    interestReceived: "Interest received",
    interestForecast: "Interest forecast",
    interestForecastDesc: "Sum of the future schedule interest payments to the investor of the Outstanding investment(s).",
    feesExpense: "Fees expense",
    feesExpenseDesc: "Total amount paid to the Platform related to the Outstanding investment(s).",
    accruedInterestExpense: "Accrued interest expense",
    accruedInterestExpenseDesc: "Expense related to the sum of the daily interest payments accumulated since the last coupon payment until the subsequent settlement date of the outstanding investment(s). This amount is charged from investors to allow them to receive in full the future coupon payments.",
    pastDueDays: "Past due days",
    pastDueAmount: "Past due amount",
    trancheN: "Tranche #",
    invest: "Invest",
    comingSoon: "Coming soon",
    mobilePhone: "Mobile phone",
    createAccount: "Create account",
    portfolioOrigin: "Origin of portfolio",
    riskProfile: "Country risk profile",
    investmentGrade: "Investment-grade",
    debentureType: "Debenture type",
    seniorSecured: "Senior secured",
    tenureMonths: "Tenure (months)",
    paymentFrequency: "Payment frequency",
    creditLimit: "Credit limit",
    outstandingPayments: "Outstanding payments",
    totalAssets: "Total assets",
    committed: "Committed",
    investments: "Investments",
    netProfitability: "Net average profitability",
    netProfitabilityDesc: "Sum of all coupon payments, repaid principal and potential late payment fees (when applicable) net of service charges and potential charge offs (when applicable) divided by the sum of all the invested money. The figure is presented in an annualized format.",
    interestReceivedDesc: "Sum of paid interest to the investor related to the Outstanding investment(s)",
    showLifetimeIncome: "Show lifetime income",
    showLifetimeIncomeDesc: "By checking this box, investors can get the results not only covering Outstanding investment(s) but also including Repaid investment(s).",
    current: "Current",
    past15: "Past due (1-15)",
    past30: "Past due (16-30)",
    past60: "Past due (31-60)",
    past61: "Past due (61+)",
    outstandingInvestments: "Outstanding investments",
    noOutstanding: "You have no outstanding investments.",
    outstandingPrincipalAuto: "Outstanding principal (Autoinvest)",
    dpd: "Days past due",
    personalDetails: "Personal details",
    residentialAddress: "Residential address",
    citizenship: "Nationality",
    gender: "Gender",
    countryOfBirth: "Country of birth",
    postalCode: "Postal code",
    city: "City",
    street: "Street",
    iAmSingaporeResident: "I am Singapore resident",
    passportNumber: "Passport number",
    passportExpiry: "Passport expiry date",
    nricNumber: "Singapore national card ID (NRIC/FIN) number",
    taxResidence: "Tax residence country",
    taxIdNumber: "Tax identification number",
    accreditedStatusVerification: "Accredited investor status verification",
    accreditedStatusDesc: "Please fill in the questionnaire below by ticking the suitable answer. This will allow us to assess whether you qualify for investment with Kilde, in line with our current regulatory license.",
    repaidInvestments: "Repaid investments",
    noRepaid: "You have no repaid investments.",
    nextCapitalCallDates: "Next Capital Call Dates",
    capitalCallSubmitNoticeBy: "Submit Notice by",
};

export default messages;
